var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Header"},[_c('Header',{attrs:{"ismenu":true}})],1),_c('div',{staticClass:"header_box"}),_c('router-view'),_c('Footer'),(_vm.$store.state.load)?_c('div',{staticClass:"shadeLoad fx2"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-loader"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }